import React from "react";
import {NewsCardBody} from "./NewsCardBody";
import {formatLongDate, isUnavailable} from "../../util";

const cleanTitle = (title) => {
    return title.replace(':','')
}

const NewsCard = ({item, project, cardSize=1, extraClasses = ''}) => {
    const pubDate = formatLongDate(new Date(item.pubDate))
    let available = false
    let projectName = ''
    let projectLink = ''
    if (project !== undefined) {
        projectLink = <a href={project.url}>{project.name}</a>
        projectName = project.name
        available = !isUnavailable(project)
    }

    let articleLink = ''
    if ( available ) {
        articleLink = <a className="btn btn-primary btn-sm me-3 mb-2" href={item.link}>View article at {projectName}</a>
    }

    let cardWidth = 'col-12 col-lg-6 col-xxl-4'
    if ( cardSize === 2 ) {
        cardWidth = 'col-12 col-lg-6 col-xxl-8'
    } else if ( cardSize === 3 ) {
        cardWidth = 'col-12 col-lg-12 col-xxl-8'
    } else if ( cardSize === 4 ) {
        cardWidth = 'col-12 col-lg-12 col-xxl-4'
    }

    return (
        <>
            <div className={`${cardWidth} card border-0 news-item-card ${extraClasses}`}>
                <div className="card-body shadow-md">
                    <h3 className="card-title mb-2" dangerouslySetInnerHTML={{__html: cleanTitle(item.title)}} />
                    <div className="card-subtitle text-muted mb-2">From {available ? projectLink : projectName}</div>
                    <NewsCardBody description={item.description}/>
                    <div className="vc-card-footer pb-3">
                        {articleLink}
                        <div className="card-subtitle published text-muted">{pubDate}</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewsCard